<div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" fxLayout="column" fxLayoutGap="10px">
  <div class="flex-row">
    <h2 class="flex-cell page-header">Mantenimiento De Destinatario
    </h2>
  </div>
  <article class="table-header" *ngIf="canAddOrEdit">
    <button class="button1" color="primary" mat-icon-button (click)="addRow()">
      <mat-icon title='Agregar fila'>add_circle</mat-icon>
    </button>
    <button class="button1" color="primary" mat-icon-button (click)="save()" [disabled]="saveButtonDisabled">
      <mat-icon title='Salvar'>save</mat-icon>
    </button>
    <!-- <button class="button1" color="primary" mat-icon-button  (click)="refresh()"> <mat-icon title='Actualizar'>refresh</mat-icon></button> -->
  </article>
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>
  <div #tableContainer class="table-container">
    <table mat-table matSort [dataSource]="dataSource" (matSortChange)="onSortChange()" #dataTable >
      <ng-container matColumnDef="codDealer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cód Destinatario
          <rem-string-filter #tableFilter columnDef="codDealer"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div class="cell-width-mtext" *ngIf="!element.isAdd && !element.isEdit">
            {{element.codDealer}}
          </div>
          <mat-form-field #codDealerField class="cell-width-mtext" *ngIf="element.isAdd || element.isEdit"
                          appearance="fill">
            <input matInput required minlength="1" maxlength=5 [(ngModel)]="element.codDealer " autocomplete="off"
                   (change)="checkId(element, codDealerField)"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'codDealer')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="nombreDealer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre Destinatario
          <rem-string-filter #tableFilter columnDef="nombreDealer"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription">
          <div class="cell-width-med-decription" *ngIf="!element.isAdd && !element.isEdit">
            {{element.nombreDealer}}
          </div>
          <mat-form-field class="cell-width-med-decription" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput required minlength="1" maxlength=45 [(ngModel)]="element.nombreDealer" autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'nombreDealer')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="duns">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> DUNS
          <rem-string-filter #tableFilter columnDef="duns"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
          <div class="cell-width-lgtext" *ngIf="!element.isAdd && !element.isEdit">
            {{element.duns}}
          </div>
          <mat-form-field class="cell-width-lgtext breakwrap" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput maxlength=10 [(ngModel)]="element.duns" autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'duns')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="dlDomicilio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Domicilio
          <rem-string-filter #tableFilter columnDef="dlDomicilio"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription breakwrap">
          <div class="cell-width-med-decription breakwrap" *ngIf="!element.isAdd && !element.isEdit">
            {{element.dlDomicilio}}
          </div>
          <mat-form-field class="cell-width-med-decription" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput required minlength="1" maxlength=45 [(ngModel)]="element.dlDomicilio" autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'dlDomicilio')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="dlCiudad">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ciudad
          <rem-string-filter #tableFilter columnDef="dlCiudad"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription">
          <div class="cell-width-med-decription" *ngIf="!element.isAdd && !element.isEdit">
            {{element.dlCiudad}}
          </div>
          <mat-form-field class="cell-width-med-decription" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput required minlength="1" maxlength=35 [(ngModel)]="element.dlCiudad" autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'dlCiudad')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="dlCodPcia">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cód Provincia
          <rem-string-filter #tableFilter columnDef="dlCodPcia"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          <div class="cell-width-smtext" *ngIf="!element.isAdd && !element.isEdit">
            {{element.dlCodPcia}}
          </div>
          <mat-form-field class="cell-width-smtext" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput maxlength=2 required pattern="[A-Za-z]{1,2}" [(ngModel)]="element.dlCodPcia"
                   autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'dlCodPcia')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="dlDescPcia">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Provincia
          <rem-string-filter #tableFilter columnDef="dlDescPcia"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription">
          <div class="cell-width-med-decription" *ngIf="!element.isAdd && !element.isEdit">
            {{element.dlDescPcia}}
          </div>
          <mat-form-field class="cell-width-med-decription" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput required minlength="1" maxlength=25 [(ngModel)]="element.dlDescPcia" autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'dlDescPcia')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="dlCodPostal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cód Postal
          <rem-string-filter #tableFilter columnDef="dlCodPostal"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
          <div class="cell-width-lgtext" *ngIf="!element.isAdd && !element.isEdit">
            {{element.dlCodPostal}}
          </div>
          <mat-form-field class="cell-width-lgtext" *ngIf="element.isAdd || element.isEdit" appearance="fill">
                    <input matInput maxlength = 10 required pattern="[a-zA-Z0-9]{1,10}" [(ngModel)]="element.dlCodPostal" autocomplete="off"/>

            <mat-icon matPrefix *ngIf="isDirty(element,'dlCodPostal')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="dlPais">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> País
          <rem-string-filter #tableFilter columnDef="dlPais"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          <div class="cell-width-smtext" *ngIf="!element.isAdd && !element.isEdit">
            {{element.dlPais}}
          </div>
          <mat-form-field class="cell-width-smtext" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput maxlength=2 required pattern="[A-Za-z]{1,2}" [(ngModel)]="element.dlPais"
                   autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'dlPais')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="nroIibb">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nro IIBB
          <rem-string-filter #tableFilter columnDef="nroIibb"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext breakwrap">
          <div class="cell-width-xltext breakwrap" *ngIf="!element.isAdd && !element.isEdit">
            {{element.nroIibb}}
          </div>
          <mat-form-field class="cell-width-xltext breakwrap" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput maxlength=16 required pattern="[0-9-]{1,18}" [(ngModel)]="element.nroIibb"
                   autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'nroIibb')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>


      <ng-container matColumnDef="nroCuit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nro CUIT
          <rem-string-filter #tableFilter columnDef="nroCuit"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-xltext">
          <div class="cell-width-xltext breakwrap" *ngIf="!element.isAdd && !element.isEdit">
            {{element.nroCuit}}
          </div>
          <mat-form-field class="cell-width-xltext breakwrap" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput maxlength=16 required pattern="[0-9-]{1,18}" [(ngModel)]="element.nroCuit"
                   autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'nroCuit')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>


      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Correo
          <rem-string-filter #tableFilter columnDef="email"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription breakwrap">
          <div class="cell-width-med-decription breakwrap" *ngIf="!element.isAdd && !element.isEdit">
            {{element.email}}
          </div>
          <mat-form-field class="cell-width-med-decription" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput maxlength=30 [(ngModel)]="element.email" autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'email')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="condicionIva">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Condición IVA
          <rem-string-filter #tableFilter columnDef="condicionIva"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription">
          <div class="cell-width-med-decription" *ngIf="!element.isAdd && !element.isEdit">
            {{element.condicionIva}}
          </div>
          <mat-form-field class="cell-width-med-decription" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput maxlength=25 [(ngModel)]="element.condicionIva" autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'condicionIva')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="tipoDocAfip">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo de doc AFIP
          <rem-string-filter #tableFilter columnDef="tipoDocAfipFilter"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
          <div class="cell-width-lgtext" *ngIf="!element.isAdd && !element.isEdit">
            <mat-select class="mat-no-arrow readonly-block " placeholder="{{element.tipoDocAfip}}"
                        [(ngModel)]="element.tipoDocAfip" required>
              <mat-option value='80'>CUIT(80)</mat-option>
              <mat-option value='86'>CUIL(86)</mat-option>
              <mat-option value='96'>DNI(96)</mat-option>
            </mat-select>
          </div>
          <mat-form-field class="cell-width-lgtext" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <mat-select placeholder="Tipo de doc AFIP" [(ngModel)]="element.tipoDocAfip" required>
              <mat-option value='80'>CUIT(80)</mat-option>
              <mat-option value='86'>CUIL(86)</mat-option>
              <mat-option value='96'>DNI(96)</mat-option>
            </mat-select>

            <mat-icon matPrefix *ngIf="isDirty(element,'tipoDocAfip')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="observaciones">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Observaciones
          <rem-string-filter #tableFilter columnDef="observaciones"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription">
          <div class="cell-width-med-decription" *ngIf="!element.isAdd && !element.isEdit">
            {{element.observaciones}}
          </div>
          <mat-form-field class="cell-width-med-decription" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <textarea matInput maxlength=255 [(ngModel)]="element.observaciones"></textarea>
            <mat-icon matPrefix *ngIf="isDirty(element,'observaciones')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>


      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Estado
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div *ngIf="!element.isEdit; else statusBox">
            <span *ngIf="element.estado">Active</span>
            <span *ngIf="!element.estado">Inactive</span>
          </div>
          <ng-template #statusBox>
            <mat-form-field #estadoField appearance="fill" class="cell-width-mtext">
              <mat-select [(ngModel)]="element.estado" (selectionChange)="checkActiveRelation(element, estadoField)" name="estado">
                <mat-option [value]=true>
                  Active
                </mat-option>
                <mat-option [value]=false>
                  Inactive
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="isDirty(element,'estado')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="fecCreacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Creación
          <rem-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.fecCreacion  | date:'dd/MM/yyyy'}}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="usrCreacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Usu Creación
          <rem-string-filter #tableFilter columnDef="usrCreacion"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.usrCreacion}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="fecModif">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Modificación
          <rem-date-filter #tableFilter columnDef="fecModif" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.fecModif  | customDate}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="usrModif">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Usu Modificación
          <rem-string-filter #tableFilter columnDef="usrModif"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.usrModif}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="isEdit">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="btn-edit" *ngIf="canAddOrEdit">
            <div *ngIf="!element.isEdit && !element.isAdd">
              <button class="button1" color="secondary" mat-icon-button (click)="editRow(element)">
                <mat-icon title='Edit'>create</mat-icon>
              </button>
            </div>
          </div>
          <div class="btn-edit" *ngIf="canAddOrEdit">
            <div *ngIf="element.isEdit || element.isAdd">
              <button class="button1" color="tertiary" mat-icon-button (click)="cancelRow(element)">
                <mat-icon title='Edit'>cancel</mat-icon>
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

    </table>

  </div>
  <mat-paginator [length]="resultsLength" [pageSize]="pageSize" [pageSizeOptions]="[10, 15, 20, 25]" (page)="updatePageState()"></mat-paginator>
</div>
